

@if (passo) {
  <div class="passo-item-solo">
    <div class="icon">
      <img [src]="findIconPasso(passo)" [alt]="passo.descricao" [title]="passo.descricao"/>
    </div>
    <p class="title">{{passo.descricao}}</p>
    <app-button [customStyle]="'border: 1px solid #007AC2; color: #007AC2 !important; background: white'"
    [txt]="'SAIBA MAIS'" (click)="irParaSaibaMais(passo)"></app-button>
  </div>
}
@if (!passo) {
  <div id="container-cards-passo">
    @for (item of passos; track item) {
      <div class="passo-item">
        <div class="icon-name">
          <div class="icon">
            <img [src]="findIconPasso(item)" [alt]="item.descricao" [title]="item.descricao"/>
          </div>
          <p class="title">{{item.descricao}}</p>
        </div>
        <app-button [customStyle]="'border: 1px solid #007AC2; color: #007AC2; background: white'"
        [txt]="'SAIBA MAIS'" (click)="irParaSaibaMais(item)"></app-button>
      </div>
    }
  </div>
}

